import {
  TIPO_DESCONTO_PROMOCAO_PARA_KIT,
  TIPO_DESCONTO_PROMOCAO_PARA_TOTAL,
  TIPO_DESCONTO_PROMOCAO_PARA_FRETE,
  TIPO_DESCONTO_PROMOCAO_PARA_FRETE_TODOS,
  TIPO_DESCONTO_PROMOCAO_PARA_FRETE_PRIMEIRO_KIT,
} from '../constantsPromocao'
import { PLANO_ANUAL, PLANO_TRIMESTRAL } from '../../../constants'

const multiplicarPorUmAno = ( valor ) => valor * 12
const multiplicarPorUmTrimestre = ( valor ) => valor * 3

export const getValorBaseDesconto = ( { tipoDesconto, valorPlanoConclusao, freteEntrega } ) => {
  return {
    [ TIPO_DESCONTO_PROMOCAO_PARA_KIT.slug ]: valorPlanoConclusao,
    [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE.slug ]: freteEntrega,
    [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE_TODOS.slug ]: freteEntrega,
    [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE_PRIMEIRO_KIT.slug ]: freteEntrega,
    [ TIPO_DESCONTO_PROMOCAO_PARA_TOTAL.slug ]: valorPlanoConclusao + freteEntrega,
  }[ tipoDesconto ]
}

export const sanitizeDiscount = ( { valorPromocao, freteEntrega, tipoDesconto, isPercentual } ) => {
  const valueForDiscountOnFirstKitShipment = !isPercentual && valorPromocao > freteEntrega ? freteEntrega : valorPromocao
  return {
    [ TIPO_DESCONTO_PROMOCAO_PARA_KIT.slug ]: valorPromocao,
    [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE.slug ]: valueForDiscountOnFirstKitShipment,
    [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE_TODOS.slug ]: !isPercentual && valorPromocao > multiplicarPorUmAno( freteEntrega ) ? multiplicarPorUmAno( freteEntrega ) : valorPromocao,
    [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE_PRIMEIRO_KIT.slug ]: valueForDiscountOnFirstKitShipment,
    [ TIPO_DESCONTO_PROMOCAO_PARA_TOTAL.slug ]: valorPromocao
  }[ tipoDesconto ]
}

export const calcularValorTotalPromocao = ( {
  valorDescontado,
  desconto,
  temPercentual,
  valorPlanoConclusao,
  tipoDesconto,
  tipoPlano,
} ) => {
  const valorDescontoFretePrimeiroKit = () => {
    return temPercentual ? ( valorDescontado * desconto ) / 100 : desconto
  }

  const compensacaoPlano = ( valor ) => {
    if ( tipoPlano === PLANO_ANUAL.visualizacao ) {
      return multiplicarPorUmAno( valor )
    }
    if ( tipoPlano === PLANO_TRIMESTRAL.visualizacao ) {
      return multiplicarPorUmTrimestre( valor )
    }
    return valor
  }

  const calculosPorTipoDesconto = {
    [ TIPO_DESCONTO_PROMOCAO_PARA_TOTAL.slug ]: () => temPercentual ? ( compensacaoPlano( valorPlanoConclusao ) * desconto ) / 100 : desconto,
    [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE_TODOS.slug ]: () => temPercentual ? ( compensacaoPlano( valorDescontado ) * desconto ) / 100 : desconto,
    [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE.slug ]: valorDescontoFretePrimeiroKit,
    [ TIPO_DESCONTO_PROMOCAO_PARA_FRETE_PRIMEIRO_KIT.slug ]: valorDescontoFretePrimeiroKit,
    'default': () => temPercentual ? ( valorPlanoConclusao * desconto ) / 100 : desconto
  }

  return calculosPorTipoDesconto[ tipoDesconto ] ? calculosPorTipoDesconto[ tipoDesconto ]() : calculosPorTipoDesconto.default()
}
